// src/layouts/components/AppHeader.jsx

import { useState } from "react";
import {
  Link,
  useNavigate
} from "react-router-dom";
// import LanguageSwitcher from "../../locales/LanguageSwitcher";
import UserMenu from "./UserMenu";
import LoginModal from "../../components/modals/web-modals/LoginModal";
import SignUpModal from "../../components/modals/web-modals/SignUpModal";
import AVIcon from "../../components/icons/AllVoicedIcons";
import { useTranslation } from "react-i18next";
import FullscreenControl from "./FullscreenControl";

export default function AppHeader({
  sidebarOpen,
  isDesktopViewport,
  onToggleSidebar,
  user,
  effectiveRole
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [isLoginOpen, setLoginOpen] = useState(false);
  const [isSignUpOpen, setSignUpOpen] = useState(false);

  return (
    <header className="app-topbar">
      <div className="app-topbar__left">
        <button
          type="button"
          className="app-menu-trigger"
          title={t("menu", {
            defaultValue: sidebarOpen
              ? "Close navigation"
              : "Open navigation"
          })}
          aria-label={t("menu", {
            defaultValue: sidebarOpen
              ? "Close navigation"
              : "Open navigation"
          })}
          aria-expanded={sidebarOpen}
          aria-hidden={isDesktopViewport ? "true" : undefined}
          onClick={onToggleSidebar}
        >
          <AVIcon
            icon="menu"
            size={25}
          />
        </button>

        <Link
          className="app-topbar__brand"
          to="/app"
          aria-label={t("all_voiced_dashboard", {
            defaultValue: "All-Voiced dashboard"
          })}
        >
          <span
            className="app-topbar__brand-icon"
            aria-hidden="true"
          >
            <AVIcon
              icon="isotypePositive"
              size={27}
            />
          </span>
        </Link>
      </div>

      <div className="top-right-controls">
        {/* <div className="language-position">
          <LanguageSwitcher />
        </div> */}

        <FullscreenControl />

        <div className="user-position">
          {user ? (
            <UserMenu
              navigate={navigate}
              effectiveRole={effectiveRole}
            />
          ) : (
            <div className="user-menu hover-user-menu">
              <button
                type="button"
                className="menu-icon"
                onClick={() => setLoginOpen(true)}
                title={t("login", {
                  defaultValue: "Login"
                })}
                aria-label={t("login", {
                  defaultValue: "Login"
                })}
              >
                <AVIcon
                  icon="login"
                  size={36}
                  color="#209385"
                />
              </button>
            </div>
          )}
        </div>
      </div>

      <LoginModal
        isOpen={isLoginOpen}
        onRequestClose={() => setLoginOpen(false)}
        openSignUpModal={() => {
          setLoginOpen(false);
          setSignUpOpen(true);
        }}
      />

      <SignUpModal
        isOpen={isSignUpOpen}
        onRequestClose={() => setSignUpOpen(false)}
        openLoginModal={() => {
          setSignUpOpen(false);
          setLoginOpen(true);
        }}
      />
    </header>
  );
}
